export enum ECardListCategory {
  GROUP_POLICY_USERS = 'group_policy_users',
  POLICIES = 'policies',
}
